import {
  CustomerCards,
  CustomerConfiguration,
  CustomerModules,
  GuestInformationResponse,
  OrderLocation,
  OrderModule,
  OrderRequestData,
} from './order-types';

import { createGet, createPost, hhmmToEuropeTimeZone } from './util';

const get = createGet('order');
const post = createPost('order');

export interface GetDeliveryLocationsAndProductsParams {
  module: OrderModule;
  deliveryTime: string;
}

export async function getDeliveryLocationsAndProducts(
  reqData: GetDeliveryLocationsAndProductsParams
) {
  const reponse = await get<OrderLocation[]>('/getDeliverylocations', {
    data: {
      module: reqData.module,
      deliverytime: reqData.deliveryTime,
    },
  });

  return reponse.data;
}

export async function getOrderConfiguration() {
  const response = await get<CustomerConfiguration>('/getCustomerConfiguration');
  return response.data;
}

export async function sendOrder(data: OrderRequestData) {
  const timezoneAdjustedDeliveryTimeStr = hhmmToEuropeTimeZone(data.order.selecteddeliverytime);

  const newData = {
    ...data,
    order: {
      ...data.order,
      selecteddeliverytime: timezoneAdjustedDeliveryTimeStr,
    },
  };

  return post<{ grandtotal: number }>('/postOrder', { data: newData });
}

export interface OrderLoginParams {
  username: string;
  password: string;
  logintype: 'password' | 'birthdate';
}

export function loginToOrderSystem(loginData: OrderLoginParams) {
  return post<{ token?: string }>('/authenticateUser', { data: loginData });
}

export async function getCustomerModules() {
  return get<CustomerModules>('/getCustomerModules', {
    skipAuth: true,
  });
}

export async function getGuestInformation() {
  return get<GuestInformationResponse>('/getGuestInformation');
}

export async function getCustomerCards() {
  return get<CustomerCards>('/getCustomerCards', {
    skipAuth: true,
  });
}
